import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import { register as registerSwiperElements } from 'swiper/element/bundle';
registerSwiperElements();

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    ngZoneEventCoalescing: true,
  })
  .catch((err) => console.error(err));

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker
//     .register('/firebase-messaging-sw.js', { scope: '/' })
//     .then((registration) => {
//       console.log('Service Worker registered with scope:', registration.scope);
//       if (this && typeof (this as any)?.setupMessaging == 'function') {
//         (this as any).setupMessaging();
//       }
//       //
//     })
//     .catch((err) => {
//       console.error('Service Worker registration failed:', err);
//     });
// }
